import * as colors from 'components/common/colorConstants';

export const NAME = {
  triggerText: '{NAME}',
  color: colors.blue6,
};

export const CONNECT_WITH_CUSTOMER = {
  triggerText: '{CONNECT_WITH_CUSTOMER}',
  color: colors.green4,
};
